module.exports = __webpack_public_path__ + "static/media/brick-toys.69724ed1.svg";